import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { OnboardingFlowControllerPageRoutingModule } from './onboarding-flow-controller-routing.module';

import { OnboardingFlowControllerPage } from './onboarding-flow-controller.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OnboardingFlowControllerPageRoutingModule
  ],
  declarations: [OnboardingFlowControllerPage]
})
export class OnboardingFlowControllerPageModule {}
